import React from 'react';
import { callEventBiology, useBiology } from "../../../../../contexts/PlanOperationContext/Biology";
import { getTabBiology, setTabBiology, useTabBiology } from "../../../../../contexts/PlanOperationContext/TabBiology";
import { KEY_STORAGE, OPERATION_TYPE } from "../../../../../util/varibles/constants";
import { cloneObj } from "../../../../../util/varibles/global";
import { IPropsChildren } from "../../../../../util/varibles/interface";
import { getKeyUnit } from "../../../util";
import styles from './style.module.scss';

let countTime = 0;

const areEqual = (prevProps: IProps, nextProps: IProps) => {
    const isChange = prevProps.isError !== nextProps.isError
        || prevProps.isActive !== nextProps.isActive
        || prevProps.message !== nextProps.message
        || prevProps.messageText !== nextProps.messageText
        || JSON.stringify(prevProps.style) !== JSON.stringify(nextProps.style)
        || JSON.stringify(prevProps.data) !== JSON.stringify(nextProps.data)

    return !isChange
};

interface IProps extends IPropsChildren {
    data: any
    isError?: boolean
    isActive?: boolean
    message?: any
    messageText?: any
    style?: any

    types?: OPERATION_TYPE[]

    onContext?(e: React.MouseEvent<HTMLDivElement>): void
}

const Card: React.FC<IProps> = React.memo(props => {
    const {
        data,
        isError = false,
        message,
        messageText,
        style,
        children,
        types = [],
        onContext
    } = props;

    const id = getKeyUnit(data)
    const [checked] = useTabBiology(state => !!state.selected[id])
    const [isAllowedToCreate] = useBiology(state => state.isAllowedToCreate);
    const { onDragStart, onDragEnd } = callEventBiology();
    const setTab = setTabBiology();
    const get = getTabBiology();

    const handleChange = () => {
        setTab(({ selected }) => {
            const value = cloneObj(selected);
            if (!checked) {
                value[id] = data;
            } else {
                delete value[id];
            }
            localStorage.setItem(KEY_STORAGE.UNITS_SELECTED, JSON.stringify(value));
            return {
                selected: value,
            };
        });
    }

    const handleMouseDown = (e: any) => {
        if (e.button !== 0)
            return;

        if (isError)
            return;

        document.addEventListener('mouseup', handleMouseUp);
        document.body.setAttribute('data-is-prevent-select', 'true');

        if (checked)
            countTime = Date.now();
        else {
            handleChange()
        }
    };

    const handleMouseUp = () => {
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.setAttribute('data-is-prevent-select', 'false');

        if ((Date.now() - countTime) < 500 && checked) {
            handleChange();
        }
    };

    const handleContextMenu = (e: any) => {
        e.preventDefault();
        if (onContext)
            onContext(e);
    }

    const handleDragStart = (e: React.DragEvent) => {
        const { selected = {} } = get()
        onDragStart(e, selected, types);
    }

    if (!isAllowedToCreate) {
        return <div
            className={styles.card}
            style={style}
            onContextMenu={handleContextMenu}
        >
            {children}
            <div className={styles['drag-view']} style={{ cursor: "default" }}>
                {message && <div className={styles.note} title={messageText ? messageText : message}>{message}</div>}
            </div>
        </div>
    }

    return <div
        className={styles.card}
        data-checked={checked}
        onMouseDown={handleMouseDown}
        onContextMenu={handleContextMenu}
        style={style}
    >
        {children}
        <div
            className={styles['drag-view']}
            draggable={!isError}
            onDragStart={(e) => !isError ? handleDragStart(e) : null}
            onDragEnd={onDragEnd}
        >
            {message && <div className={styles.note} title={messageText ? messageText : message}>{message}</div>}
        </div>
    </div>;
}, areEqual);

export default Card;